import { Block, idGenerator } from '../idGenerator.utils';
import { RelatedPostsData } from './createRelatedPostsData.utils';

export const relatedPostsBlockType = 'relatedPosts';

export const addRelatedPostsBlock = (contentRecommendationsData: RelatedPostsData, body: Array<Block>) => {
  const { title, articles, blockPosition } = contentRecommendationsData;
  const contentRecommendationsBlock = {
    type: relatedPostsBlockType,
    dataId: idGenerator(),
    title,
    articles,
  };
  if (blockPosition > body.length || blockPosition === body.length) {
    return [...body, contentRecommendationsBlock];
  }
  if (blockPosition > 0) {
    return [...body.slice(0, blockPosition), contentRecommendationsBlock, ...body.slice(blockPosition, body.length)];
  }
  if (blockPosition === 0) {
    return [contentRecommendationsBlock, ...body];
  }
  return body;
};
